import { Card, Divider, Typography, Row, Col } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import ConvertToVendor from "../../../Modal/ConvertToVendor";
import TimeSlot from "../../../Components/TimeSlot";
import toast from "react-hot-toast";
import globalRequest from "../../../utils/global/globalRequest";
import * as Apis from "../../../utils/helper/enum";
import LatestLocationMap from "../../../Modal/LatestLocationMap";
import { convertDateString, convertSlote } from "../../../utils/helper/utils";

const ViewDriver = () => {
  const navigate = useNavigate();
  const [isConvertToVendorModalOpen, setIsConvertToVendorModalOpen] =
    useState(false);
  const [isLatestLocationMapModalOpen, setIsLatestLocationMapModalOpen] =
    useState(false);
  const [latestLocationCoordinates, setLatestLocationCoordinates] = useState(
    {}
  );
  const handleConvertToVendorOk = () => {
    setIsConvertToVendorModalOpen(false);
  };
  const handleConvertToVendorCancel = () => {
    setIsConvertToVendorModalOpen(false);
  };

  let { id } = useParams();
  const [driverDetail, setDriverDetail] = useState([]);

  const getDriverDetail = async (id) => {
    try {
      let response = await globalRequest(
        Apis.MANAGE_DRIVERS.GET_DRIVERS_DETAIL + "/" + id,
        "get",
        {},
        {},
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let data = apiResponse?.data;
        setDriverDetail(data);
        // setPreviewImage(`https://rabbitholebucket.s3.eu-north-1.amazonaws.com/`+data?.driverDetail?.profileImage);
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  const handleLatestLocationMapOk = async () => {
    setIsLatestLocationMapModalOpen(false);
  };
  const handleLatestLocationMapCancel = () => {
    setIsLatestLocationMapModalOpen(false);
  };

  useEffect(() => {
    // getAllZones();
    // getAllVehicles();
    if (id) getDriverDetail(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Card>
        <Typography className="text-xl font-semibold" align={"left"}>
          <LeftOutlined className="mr-2" onClick={() => navigate(-1)} />
          View Driver
        </Typography>
        <Divider />
        <div>
          <Row>
            <Col xs={24} sm={12} md={12} lg={12}>
              <div className="mr-4 my-5">
                <div className="font-semibold text-[17px]">Driver name</div>
                <div className="text-sm">
                  {driverDetail?.firstName} {driverDetail?.lastName}
                </div>
              </div>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <div className="mr-4 my-5">
                <div className="font-semibold text-[17px]">Mobile number</div>
                <div className="text-sm">{driverDetail?.mobileNo}</div>
              </div>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <div className="mr-4 my-5">
                <div className="font-semibold text-[17px]">Email address</div>
                <div className="text-sm">{driverDetail?.email}</div>
              </div>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <div className="mr-4 my-5">
                <div className="font-semibold text-[17px]">Zone</div>
                <div className="text-sm">
                  {driverDetail?.driverDetail?.zones?.length > 0
                    ? driverDetail.driverDetail.zones.map((z) => z.name).join(", ")
                    : driverDetail?.driverDetail?.zone?.name || "-"}
                </div>
              </div>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <div className="mr-4 my-5">
                <div className="font-semibold text-[17px]">Vehicle Type</div>
                <div className="text-sm">
                  {driverDetail?.driverDetail?.vehicleType?.name}
                </div>
              </div>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <div className="mr-4 my-5">
                <div className="font-semibold text-[17px]">Image</div>
                <div className="text-sm">
                  <img
                    src={
                      driverDetail?.driverDetail?.profileImage
                        ? `https://rabbitholebucket.s3.eu-north-1.amazonaws.com/${driverDetail?.driverDetail?.profileImage}`
                        : "images/1.png"
                    }
                    alt="User"
                    className="w-[50px] h-[50px] rounded"
                  />
                </div>
              </div>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <div className="mr-4 my-5">
                <div className="font-semibold text-[17px]">Plate Number</div>
                <div className="text-sm">
                  {driverDetail?.driverDetail?.plateNumber}
                </div>
              </div>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <div className="mr-4 my-5">
                <div className="font-semibold text-[17px]">Price/KM</div>
                <div className="text-sm">
                  {driverDetail?.driverDetail?.pricePerKm}
                </div>
              </div>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <div className="mr-4 my-5">
                <div className="font-semibold text-[17px]">Minimum Payout</div>
                <div className="text-sm">
                  {driverDetail?.driverDetail?.minPayout}
                </div>
              </div>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <div className="mr-4 my-5">
                <div className="font-semibold text-[17px]">Max Distance</div>
                <div className="text-sm">
                  {driverDetail?.driverDetail?.maxDistance}
                </div>
              </div>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <div className="mr-4 my-5">
                <div className="font-semibold text-[17px]">Latest Location</div>
                  <div className="text-sm">
                    {driverDetail?.driverDetail?.lastLocationJson?.lat && (
                      <div
                        className="text-sm text-[#39b2f3] cursor-pointer"
                        onClick={() => {
                          if (!driverDetail?.driverDetail?.lastLocationJson) {
                            return false; // Exit if location is not set
                          }
                          setIsLatestLocationMapModalOpen(true);
                          setLatestLocationCoordinates(driverDetail.driverDetail.lastLocationJson);
                        }}
                      >
                        {driverDetail?.driverDetail?.lastLocationJson?.lat}
                        {driverDetail?.driverDetail?.lastLocationJson?.lng ? ", " : ""}
                        {driverDetail?.driverDetail?.lastLocationJson?.lng}
                      </div>
                    )}
                  </div>
              </div>
            </Col>
            <Col xs={24} sm={12} md={12} lg={12}>
              <div className="mr-4 my-5">
                <div className="font-semibold text-[17px]">Last Online Date & Time</div>
                <div className="text-sm">
                  {driverDetail?.driverDetail?.lastLocationJson?.dateTime
                    ? convertDateString(driverDetail.driverDetail.lastLocationJson.dateTime, 
                    'dd/MM/yyyy hh:mm a') : '-'}
                </div>
              </div>
            </Col>
            <Col span={24}>
              <div className="mr-4 my-5">
                <div className="font-semibold text-[17px] mb-2">Available Time slot</div>
                {driverDetail?.driverDetail?.driverTimeSlots?.map((slot, index) => (
                  <div
                    key={slot.id}
                    className="flex items-center gap-2 mb-3 flex-wrap"
                    style={{ maxWidth: "600px" }}
                  >
                    <div className="w-[120px]">
                      <input
                        type="text"
                        value={convertSlote(slot.from)}
                        disabled
                        className="w-full border px-2 py-1 rounded"
                      />
                    </div>
                    <div className="w-[120px]">
                      <input
                        type="text"
                        value={convertSlote(slot.to)}
                        disabled
                        className="w-full border px-2 py-1 rounded"
                      />
                    </div>
                    <div className="w-[80px]">
                      <input
                        type="text"
                        value={slot.tripDistance}
                        disabled
                        className="w-full border px-2 py-1 rounded"
                      />
                    </div>
                    <span className="text-sm">KM</span>
                  </div>
                ))}
              </div>
            </Col>
          </Row>
        </div>
      </Card>
      <ConvertToVendor
        isOpen={isConvertToVendorModalOpen}
        onOk={handleConvertToVendorOk}
        onCancel={handleConvertToVendorCancel}
      />
      <LatestLocationMap
        isOpen={isLatestLocationMapModalOpen}
        onOk={handleLatestLocationMapOk}
        onCancel={handleLatestLocationMapCancel}
        latestLocationCoordinates={latestLocationCoordinates}
      />
    </>
  );
};
export default ViewDriver;
